export default 'bhneoidcckdhbjhmcpgbhhnapbbbojik';
export const extensionUrl = 'http://www.gourmetrecipemanager.com'
